export const appRouter = {
  path: "/",
  name: "root",
  component: () => import("../views/"),
  redirect: "/index",
  children: [
    {
      path: "index",
      icon: "shop",
      title: "首页",
      component: () => import("@/views/index/home")
    },
    {
      path: "contact",
      icon: "friends",
      title: "查看学费",
      component: () => import("../views/contact/")
    },
    {
      path: "course",
      icon: "phone",
      title: "电话咨询",
      component: () => import("../views/video/index"),
      beforeEnter() {
        location.href = "tel:08162223099";
      }
    },
    {
      path: "chat",
      name: "Chat",
      icon: "chat",
      title: "在线咨询",
      beforeEnter() {
        location.href =
          "http://live.easyliao.com/live/chat.do?c=13094&g=25180&config=37607&tag=0";
      },
      component: () => import("../views/chat/index")
    },
    {
      path: "link",
      name: "Link",
      beforeEnter() {
        location.href =
          "http://www.xhe.cn/front/recruit/2";
      },
    },
    {
      path: "register",
      name: "Register",
      beforeEnter() {
        location.href = "https://jinshuju.net/f/4xGXfI";
      },
      component: () => import("../views/chat/index")
    }
  ]
};

export const commonRouters = [
  // {
  //   path: "/video",
  //   name: "Video",
  //   component: () => import("../views/video/index")
  // },
  {
    path: "/video/active/:active",
    name: "Video",
    component: () => import("../views/video/list"),
    // beforeRouteLeave(to, from, next) {
    //   this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //   next()
    // },
    // beforeRouteEnter(to, from, next) {
    //   next(vm => {
    //     document.body.scrollTop = vm.scrollTop
    //   })
    // }
    // scrollBehavior (to, from, savedPosition) {
    //   return { x: 0, y: 700 }
    // }
  },
  {
    path: "/vdetail/active/:active/id/:id",
    name: "Vdetail",
    component: () => import("../views/video/detail")
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/index/home")
  },
  {
    path: "/find",
    icon: "friends",
    title: "查看学费",
    component: () => import("../views/contact/")
  },
  {
    //仿微信聊天1
    path: "/chatpage",
    name: "Chatpage",
    component: () => import("@/views/landingPage/chatpage/page1")
  },
  {
    //仿微信聊天
    path: "/chatpage2",
    name: "Chatpage2",
    component: () => import("@/views/landingPage/chatpage/page2")
  },
  {
    //名师风采
    path: "/teacher",
    name: "Teacher",
    component: () => import("@/views/landingPage/teacher/index")
  },
  {
    //学生作品
    path: "/works",
    name: "Works",
    component: () => import("@/views/landingPage/works/index")
  },
  {
    //新闻中心
    path: "/news",
    name: "news",
    component: () => import("@/views/landingPage/news/index")
  },
  {
    path: "/detail/:id",
    name: "detail",
    component: () => import("@/views/landingPage/news/detail")
  },
  {
    //学校简介
    path: "/school",
    name: "School",
    component: () => import("@/views/landingPage/school/index")
  },
  {
    //就业创业
    path: "/jobs",
    name: "Jobs",
    component: () => import("@/views/landingPage/jobs/index")
  },
  {
    //学校环境
    path: "/place",
    name: "Place",
    component: () => import("@/views/landingPage/place/index")
  },
  {
    //热门课程
    path: "/class",
    name: "Class",
    component: () => import("@/views/landingPage/class/index")
  },

  {
    //咖啡9个月
    path: "/coffee",
    name: "Coffee",
    component: () => import("@/views/landingPage/coffee/index")
  },
  {
    //西点15个月
    path: "/baking15",
    name: "Baking15",
    component: () => import("@/views/landingPage/baking/baking15")
  },
  {
    //西点9个月
    path: "/baking9",
    name: "Baking9",
    component: () => import("@/views/landingPage/baking/baking9")
  },
  {
    //西点6个月
    path: "/baking6",
    name: "Baking6",
    meta: {
      keepAlive: true
    },
    component: () => import("@/views/landingPage/baking/baking6")
  },
  {
    //西点3个月
    path: "/baking3",
    name: "Baking3",
    component: () => import("@/views/landingPage/baking/baking3")
  },
  {
    //西点1个月
    path: "/baking1",
    name: "Baking1",
    component: () => import("@/views/landingPage/baking/baking1")
  },
  {
    //西餐9个月
    path: "/westfood9",
    name: "Westfood9",
    component: () => import("@/views/landingPage/westfood/westfood9")
  },
  {
    //西餐6个月
    path: "/westfood6",
    name: "Westfood6",
    component: () => import("@/views/landingPage/westfood/westfood6")
  },
  {
    //调酒2个月
    path: "/wine",
    name: "Wine",
    component: () => import("@/views/landingPage/wine/wine")
  },
  {
    //我要开店
    path: "/shop",
    name: "Shop",
    component: () => import("@/views/landingPage/shop/index")
  },
  {
    //蛋糕
    path: "/cake",
    name: "Cake",
    component: () => import("@/views/landingPage/cake/index")
  },
  {
    //春招
    path: "/spring",
    name: "Spring",
    component: () => import("@/views/landingPage/banner/spring")
  },
  {
    //学费
    path: "/tuition",
    name: "Tuition",
    component: () => import("@/views/landingPage/tuition/index")
  },
  {
    //专业总页面
    path: "/bakingAll",
    name: "BakingAll",
    component: () => import("@/views/landingPage/bakingAll/index")
  },
  {
    //女生
    path: "/girl",
    name: "Girl",
    component: () => import("@/views/landingPage/girl/index")
  },
  {
    //法式甜点
    path: "/dessert",
    name: "Dessert",
    component: () => import("@/views/landingPage/dessert/index")
  },
  {
    //初中生
    path: "/middle",
    name: "Middle",
    component: () => import("@/views/landingPage/middle/index")
  },
  {
    //创业
    path: "/business",
    name: "Business",
    component: () => import("@/views/landingPage/business/index")
  },
  {
    //泛人群 专业
    path: "/industry",
    name: "Industry",
    component: () => import("@/views/landingPage/industry/index")
  },
  {
    //烘焙表单
    path: "/bakingform",
    name: "Bakingform",
    component: () => import("@/views/landingPage/baking/bakingform")
  },
  {
    //烘焙甜点
    path: "/bakingmini",
    name: "Bakingmini",
    component: () => import("@/views/landingPage/baking/bakingmini")
  },
  {
    //蛋糕 新
    path: "/newcake",
    name: "Newcake",
    component: () => import("@/views/landingPage/cake/newcake")
  },
  {
    // 法甜 
    path: "/fatan",
    name: "Fatan",
    component: () => import("@/views/landingPage/fatan/index")
  },
  {
    //咖啡单页
    path: "/coffeepage",
    name: "Coffeepage",
    component: () => import("@/views/landingPage/coffee/coffeepage")
  },
  {
    //西点单页
    path: "/bakingpage",
    name: "Bakingpage",
    component: () => import("@/views/landingPage/baking/bakingpage")
  },
  {
    //西点单页
    path: "/bread",
    name: "Bread",
    component: () => import("@/views/landingPage/baking/bread")
  },
  {
    //港式甜品
    path: "/hksweet",
    name: "Hksweet",
    component: () => import("@/views/landingPage/coffee/hksweet")
  },
  {
    //西餐总页面
    path: "/westfoodall",
    name: "Westfoodall",
    component: () => import("@/views/landingPage/westfood/all")
  },
  {
    //西餐总页面
    path: "/zjc",
    name: "zjc",
    component: () => import("@/views/landingPage/zjc/index")
  },
  {
    //初高中学技术
    path: "/xuejishu",
    name: "xuejishu",
    component: () => import("@/views/landingPage/xuejishu/index")
  },
  {
    //男生学技术
    path: "/xuejishuboy",
    name: "xuejishuboy",
    component: () => import("@/views/landingPage/xuejishu/boy")
  },
  {
    //品牌落地页
    path: "/brand",
    name: "brand",
    component: () => import("@/views/landingPage/brand/index")
  },
  {
    //法式甜点
    path: "/fstd",
    name: "fstd",
    component: () => import("@/views/landingPage/fatan/fstd")
  },
  {
    //新版烘焙西餐
    path: "/xidian",
    name: "xidian",
    component: () => import("@/views/landingPage/xidian/index")
  },
  {
    //国朝中式点心
    path: "/guochao",
    name: "guochao",
    component: () => import("@/views/landingPage/guochao/index")
  },
  {
    //短期综合课程
    path: "/duanqi",
    name: "duanqi",
    component: () => import("@/views/landingPage/duanqi/index")
  },
  {
    path: "/test",
    name: "Test",
    component: () => import("@/views/add/test")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login")
  },
  {
    //
    path: "/pagelist",
    name: "pagelist",
    component: () => import("@/views/landingPage/pagelist/index")
  },

  {
    path: "/403",
    name: "403",
    props: {
      type: "403"
    },
    component: () => import("../views/index/home")
  },
  {
    path: "/404",
    name: "404",
    props: {
      type: "404"
    },
    component: () => import("../views/index/home")
  },
  {
    path: "/500",
    name: "500",
    props: {
      type: "500"
    },
    component: () => import("../views/error")
  },
  {
    path: "/*",
    name: "error-404",
    redirect: "/404"
  }
];

export const routers = [appRouter, ...commonRouters];
